/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { useServiceContext } from '../../../../root'
import { RcmTableDataWrapper } from '../../../rcm-table/RcmTableDataWrapper'
import { WorkflowsTable } from './WorkflowsTable'

interface WorkflowsSectionProps {
  isEosEnabled: boolean
}

export const WorkflowsSection: React.FC<WorkflowsSectionProps> = ({ isEosEnabled }) => {
  const {
    service: {
      filter: { translate }
    },
    api
  } = useServiceContext()

  const loadDataWorkflows = (
    pagingParams: any,
    filter?: any
  ): Promise<{
    elements: any[]
    totalElements: number
    hasNextPage?: boolean
  }> => {
    return new Promise((resolve) => {
      const defaultFilter = {
        pageSize: 5,
        pageStart: pagingParams?.pageStart || 0,
        sortBy: pagingParams?.sortBy || 'START_DATE',
        sortDesc: pagingParams?.sortDesc !== undefined ? pagingParams.sortDesc : true,
        _noLoadingSpinner: true
      }

      // Apply any additional filters if provided
      if (filter && Object.keys(filter).length > 0) {
        Object.assign(defaultFilter, filter)
      }

      if (isEosEnabled && pagingParams) {
        console.log('EOS enabled, using paging params:', pagingParams)
      }

      ;(isEosEnabled ? api.workflows.getWorkflowsFiltered(defaultFilter) : api.workflows.getWorkflows())
        .then(function (data: any) {
          resolve({
            elements: data.elements,
            totalElements: data.totalElements,
            hasNextPage: data.hasNextPage || false
          })
        })
        .catch(() => {
          console.log('❌ API FAILED, falling back to mock data...')
        })
    })
  }

  return (
    <>
      <h2 className="cr">{translate('WORKFLOWS_TITLE')}</h2>
      <RcmTableDataWrapper
        persistenceKey="dashboardWorkflows"
        defaultSortBy="START_DATE"
        defaultSortDesc={true}
        loadData={loadDataWorkflows}
      >
        <WorkflowsTable isEosEnabled={isEosEnabled} />
      </RcmTableDataWrapper>
    </>
  )
}
